import { render, staticRenderFns } from "./DashboardActivityList.vue?vue&type=template&id=6f35245f"
import script from "./DashboardActivityList.vue?vue&type=script&lang=js"
export * from "./DashboardActivityList.vue?vue&type=script&lang=js"
import style0 from "./DashboardActivityList.vue?vue&type=style&index=0&id=6f35245f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports